
import markerImageAT from '../images/markers/at_parcelshop-marker-2.png';
import hoverMarkerImageAT from '../images/markers/at_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockAT from '../images/markers/at_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockAT from '../images/markers/at_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageAT from '../images/markers/at_parcelshop-marker-inactive.png';

import markerImageBE from '../images/markers/be_parcelshop-marker-2.png';
import hoverMarkerImageBE from '../images/markers/be_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockBE from '../images/markers/be_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockBE from '../images/markers/be_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageBE from '../images/markers/be_parcelshop-marker-inactive.png';

import markerImageDE from '../images/markers/de_parcelshop-marker-2.png';
import hoverMarkerImageDE from '../images/markers/de_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockDE from '../images/markers/de_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockDE from '../images/markers/de_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageDE from '../images/markers/de_parcelshop-marker-inactive.png';

import markerImageDK from '../images/markers/dk_parcelshop-marker-2.png';
import hoverMarkerImageDK from '../images/markers/dk_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockDK from '../images/markers/dk_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockDK from '../images/markers/dk_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageDK from '../images/markers/dk_parcelshop-marker-inactive.png';

import markerImageES from '../images/markers/es_parcelshop-marker-2.png';
import hoverMarkerImageES from '../images/markers/es_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockES from '../images/markers/es_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockES from '../images/markers/es_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageES from '../images/markers/es_parcelshop-marker-inactive.png';

import markerImageFI from '../images/markers/fi_parcelshop-marker-2.png';
import hoverMarkerImageFI from '../images/markers/fi_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockFI from '../images/markers/fi_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockFI from '../images/markers/fi_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageFI from '../images/markers/fi_parcelshop-marker-inactive.png';

import markerImageFR from '../images/markers/fr_parcelshop-marker-2.png';
import hoverMarkerImageFR from '../images/markers/fr_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockFR from '../images/markers/fr_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockFR from '../images/markers/fr_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageFR from '../images/markers/fr_parcelshop-marker-inactive.png';

import markerImageGB from '../images/markers/gb_parcelshop-marker-2.png';
import hoverMarkerImageGB from '../images/markers/gb_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockGB from '../images/markers/gb_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockGB from '../images/markers/gb_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageGB from '../images/markers/gb_parcelshop-marker-inactive.png';

import markerImageIT from '../images/markers/it_parcelshop-marker-2.png';
import hoverMarkerImageIT from '../images/markers/it_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockIT from '../images/markers/it_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockIT from '../images/markers/it_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageIT from '../images/markers/it_parcelshop-marker-inactive.png';

import markerImageLU from '../images/markers/lu_parcelshop-marker-2.png';
import hoverMarkerImageLU from '../images/markers/lu_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockLU from '../images/markers/lu_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockLU from '../images/markers/lu_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageLU from '../images/markers/lu_parcelshop-marker-inactive.png';

import markerImageNL from '../images/markers/nl_parcelshop-marker-2.png';
import hoverMarkerImageNL from '../images/markers/nl_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockNL from '../images/markers/nl_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockNL from '../images/markers/nl_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageNL from '../images/markers/nl_parcelshop-marker-inactive.png';

import markerImageSE from '../images/markers/se_parcelshop-marker-2.png';
import hoverMarkerImageSE from '../images/markers/se_parcelshop-marker-hover-2.png';
import markerImagePaketParcelLockSE from '../images/markers/se_parcelshop-marker-paket-parcel-lock-2.png';
import hoverMarkerImagePaketParcelLockSE from '../images/markers/se_parcelshop-marker-hover-paket-parcel-lock-2.png';
import inactiveMarkerImageSE from '../images/markers/se_parcelshop-marker-inactive.png';

const countryMarkers = {
  de: {
    'parcelshop-marker-2': markerImageDE,
    'parcelshop-marker-hover-2': hoverMarkerImageDE,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockDE,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockDE,
    'parcelshop-marker-inactive': inactiveMarkerImageDE
  },
  gb: {
    'parcelshop-marker-2': markerImageGB,
    'parcelshop-marker-hover-2': hoverMarkerImageGB,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockGB,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockGB,
    'parcelshop-marker-inactive': inactiveMarkerImageGB
  },
  at: {
    'parcelshop-marker-2': markerImageAT,
    'parcelshop-marker-hover-2': hoverMarkerImageAT,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockAT,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockAT,
    'parcelshop-marker-inactive': inactiveMarkerImageAT
  },
  be: {
    'parcelshop-marker-2': markerImageBE,
    'parcelshop-marker-hover-2': hoverMarkerImageBE,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockBE,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockBE,
    'parcelshop-marker-inactive': inactiveMarkerImageBE
  },
  dk: {
    'parcelshop-marker-2': markerImageDK,
    'parcelshop-marker-hover-2': hoverMarkerImageDK,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockDK,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockDK,
    'parcelshop-marker-inactive': inactiveMarkerImageDK
  },
  fr: {
    'parcelshop-marker-2': markerImageFR,
    'parcelshop-marker-hover-2': hoverMarkerImageFR,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockFR,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockFR,
    'parcelshop-marker-inactive': inactiveMarkerImageFR
  },
  it: {
    'parcelshop-marker-2': markerImageIT,
    'parcelshop-marker-hover-2': hoverMarkerImageIT,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockIT,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockIT,
    'parcelshop-marker-inactive': inactiveMarkerImageIT
  },
  nl: {
    'parcelshop-marker-2': markerImageNL,
    'parcelshop-marker-hover-2': hoverMarkerImageNL,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockNL,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockNL,
    'parcelshop-marker-inactive': inactiveMarkerImageNL
  },
  se: {
    'parcelshop-marker-2': markerImageSE,
    'parcelshop-marker-hover-2': hoverMarkerImageSE,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockSE,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockSE,
    'parcelshop-marker-inactive': inactiveMarkerImageSE
  },
  fi: {
    'parcelshop-marker-2': markerImageFI,
    'parcelshop-marker-hover-2': hoverMarkerImageFI,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockFI,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockFI,
    'parcelshop-marker-inactive': inactiveMarkerImageFI
  },
  es: {
    'parcelshop-marker-2': markerImageES,
    'parcelshop-marker-hover-2': hoverMarkerImageES,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockES,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockES,
    'parcelshop-marker-inactive': inactiveMarkerImageES
  },
  lu: {
    'parcelshop-marker-2': markerImageLU,
    'parcelshop-marker-hover-2': hoverMarkerImageLU,
    'parcelshop-marker-paket-parcel-lock-2': markerImagePaketParcelLockLU,
    'parcelshop-marker-hover-paket-parcel-lock-2': hoverMarkerImagePaketParcelLockLU,
    'parcelshop-marker-inactive': inactiveMarkerImageLU
  }
};

export default (countryIsoA2Code, imageName, fallback) => {
  const countryImages = countryMarkers[countryIsoA2Code.toLowerCase()];
  return countryImages ? countryImages[imageName] || fallback : fallback;
};
